"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BuySellDesktopLayout", {
  enumerable: true,
  get: function get() {
    return _BuySellDesktopLayout["default"];
  }
});
Object.defineProperty(exports, "BuySellMobileLayout", {
  enumerable: true,
  get: function get() {
    return _BuySellMobileLayout["default"];
  }
});
var _BuySellDesktopLayout = _interopRequireDefault(require("./BuySellDesktopLayout"));
var _BuySellMobileLayout = _interopRequireDefault(require("./BuySellMobileLayout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }